import { ELoginMethods } from '@/lib/enums';
import { appStateService } from '@/state/app.state.service';
import { useMutation } from '@tanstack/react-query';

import { API_ROUTES } from './apiRoutes';
import useAxios from './useAxios';
import { AxiosError } from 'axios';
import { LOGIN_REQUEST_TIMEOUT_MILLISECONDS } from '@/lib/otpAuth';

const { post } = useAxios();

export interface LoginRequestData {
  publisherId: string;
  sessionId: string;
  localAddress: string | null;
  authMethod: ELoginMethods;
  profileImageUrl?: string;
  userToken?: string;
  userName?: string;
  userPassword?: string;
  otp?: {
    playerCode: string;
    accessToken: string;
  };
  os?: string;
  token?: string;
  jwt?: string;
  domain?: string;
  platform?: string;
  isIntegrationProfilesEnabled?: boolean;
}

export interface LoginResponse {
  profileImageUrl: string;
  playerProfileImage?: string;
  sessionToken: string;
  errorCode?: number;
  errorMessage?: string;
  playerId: string;
  playerName: string;
  playerCountry: string;
  offerId?: string;
}

export interface IPlayerData {
  profileImageUrl: string;
  authMethod: ELoginMethods;
  playerId: string;
  playerName: string;
  playerCountry: string;
}

export interface LoginData {
  profileImageUrl?: string;
  userToken?: string;
  userName?: string;
  userPassword?: string;
  authMethod: ELoginMethods;
  otp?: {
    playerCode: string;
    accessToken: string;
  };
  jwt?: string;
}

const getUtmHeaders = (): Record<string, string> => {
  const utms = appStateService.utms.get();
  if (!utms) return {};
  const utmParams = appStateService.utms.get() || {};
  const headers: Record<string, string> = {};
  const utmKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
  utmKeys.forEach((key) => {
    const value = utmParams[key];
    if (value) {
      headers[`x-ac-${key}`] = value; // Dynamically set the header key
    }
  });

  return headers;
};

export const useLogin = () => {
  const login = useMutation({
    mutationFn: async (data: Partial<LoginRequestData>) => {
      const headers = getUtmHeaders();

      return await post<LoginResponse>(
        API_ROUTES.LOGIN,
        { data, headers, timeout: LOGIN_REQUEST_TIMEOUT_MILLISECONDS },
        true
      );
    },
    onError: async (err: AxiosError) => {
      // await logToNewRelic(err);
      console.log('error login:', err);
    },
  });

  const getRedirectToken = useMutation({
    mutationFn: async () => {
      return await post(API_ROUTES.REDIRECT_TOKEN, { data: {}, headers: {} });
    },
    onError: async (err: AxiosError) => {
      // await logToNewRelic(err);
      console.log('error get redirect token:', err);
    },
  });

  return {
    login,
    getRedirectToken,
  };
};
